import AlreadyReportedError from "../classes/alreadyReportedError";
import checkResponse from "./checkResponse";

const noHeader = () => null;

// fetch(), reporting a request that never completed or a response the caller cannot use. It resolves
// to the response and the kind of problem checkResponse found with it, or null. A request that never
// completed rejects with AlreadyReportedError, which AppSignal ignores: the check has reported it, or
// it was cut off by the user leaving the page.
export default async function checkedFetch(url, init = {}, { expectsJson = false, silent = false } = {}) {
  const method = (init.method || "GET").toUpperCase();
  let response;

  try {
    response = await fetch(url, init);
  } catch (error) {
    if (error.name === "AbortError") {
      throw error;
    }

    checkResponse({ method, url, status: 0, header: noHeader, readBody: () => "", expectsJson, silent });
    throw new AlreadyReportedError();
  }

  const problem = checkResponse({
    method,
    url: response.url || url,
    status: response.status,
    header: (name) => response.headers.get(name),
    readBody: () => response.clone().text(),
    expectsJson,
    silent,
  });

  return { response, problem };
}
